import React from 'react';
import FontAwesome from 'react-fontawesome';
import {Row, Col, FormGroup, Label, Input} from 'reactstrap';
import './FilterExperience.css';
import {
    alertLabels, labels, marketTypes, messages, profileTypes, statusTypes,
    typeFilterDate
} from "../../util/constants";
import {FormControl, MenuItem, Button} from "@material-ui/core/umd/material-ui.production.min";
import MultiSelectField from "../multiSelect/multiSelect";
import DateRangePicker from "../DatePickerComponent/DateRangePicker";
import moment from "moment";
import {generalConfig} from "../../util/config";
import {removeTokenUserStorage, setAlertOnRedux, validRemoveTokenUserStorage} from "../../actions";
import httpHttpsRequest from '../../util/http-request/request';
import { getDataUsedClaimedOptions } from '../../util/optionsRequest';

export default class FilterExperience extends React.Component{
    constructor (props) {
        super(props);
        this.state = {
            registration:'',
            name:'',
            market:'',
            status:'',
            licensePlate:'',
            model:'',
            typeUserSelected:[],
            claimedItemsData:[],
            startDate: moment().subtract(generalConfig.intervalDaysDatePicker, 'days').startOf('day'),
            endDate: moment().endOf('day'),
            claimedItemSelected:'',
            typeFilterDate: typeFilterDate.creation,
            dataTypeUser:[{
                label:profileTypes.at,
                value:profileTypes.at
            },{
                label:profileTypes.designated,
                value:profileTypes.designated
            },{
                label:profileTypes.radar,
                value:profileTypes.radar
            }],
            dataMarket:[{
                label:marketTypes.argentina,
                value:marketTypes.argentina
            }, {
                label: marketTypes.brazil,
                value: marketTypes.brazil
            }],
            dataStatus:[{
                label:statusTypes.received,
                value:statusTypes.sent
            }, {
                label: statusTypes.reviewed,
                value: statusTypes.reviewed
            },{
                label:statusTypes.canceled,
                value:statusTypes.canceled
            }, {
                label: statusTypes.inconsistent,
                value: statusTypes.inconsistent
            }]
        };
    };

    componentWillMount (){
        this.getDataUsedClaimed();
    };

    getDataUsedClaimed = () => {
        let http = new httpHttpsRequest(getDataUsedClaimedOptions);

        http.makeRequest().then((data)=>{this.claimedSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    claimedSuccess = (response) =>{
        if(response.data && response.data.length > 0){
            this.setState({claimedItemsData:response.data});
        }else{
            this.setState({claimedItemsData:response.data});
            setAlertOnRedux(true,alertLabels.iconInfo,messages.emptyData, alertLabels.alertInfo);
        }
    };

    callBackError = (response) => {
        try {
            if (validRemoveTokenUserStorage(response.statusCode)) {
                removeTokenUserStorage();
            }
            setAlertOnRedux(true, alertLabels.iconError, JSON.parse(response.body).message, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    changeRegistration = (registration) => {
        this.setState({
            registration: registration.target.value,
        });
    };

    changeName = (name) => {
        this.setState({
            name: name.target.value,
        });
    };

    changeMarket = (market) => {
        if(market){
            this.setState({market});
        }
        else{
            this.setState({market:[]});
        }
    };

    changeStatus = (status) => {
        if(status){
            this.setState({status});
        }
        else{
            this.setState({status:[]});
        }
    };

    changeLicensePlate = (plate) => {
        this.setState({
            licensePlate: plate.target.value,
        });
    };

    changeModel = (model) => {
        this.setState({
            model: model.target.value,
        });
    };

    changeTypeUser = (typeUserSelected) => {
        if(typeUserSelected){
            this.setState({typeUserSelected});
        }
        else{
            this.setState({typeUserSelected:[]});
        }
    };

    changeClaimedItems = (claimedItemSelected) =>{
        if(claimedItemSelected){
            this.setState({claimedItemSelected});
        }
        else{
            this.setState({claimedItemSelected:[]});
        }
    };

    onChangeTypeFilterDate = (typeDate) =>{
        this.setState({typeFilterDate:typeDate});
    };

    handleEvent = (event, picker) => {
        event.preventDefault();
        const state = Object.assign({},this.state);
        state['startDate'] = picker.startDate;
        state['endDate'] = picker.endDate;
        var start = this.state.startDate.format(generalConfig.dateFormat);
        var end = this.state.endDate.format(generalConfig.dateFormat);
        state['oneDate']  = start === end;
        this.setState(state);
    };

   search = (event) =>{
        event.preventDefault();
       var params = {};
       if(this.state.typeUserSelected && this.state.typeUserSelected.value){
           params = Object.assign(params, {profile_type:this.state.typeUserSelected.value});
       }

       if(this.state.registration.length > 0){
           params = Object.assign(params, {id_user: this.state.registration});
       }

       if(this.state.name.length > 0){
           params = Object.assign(params, {user_name: this.state.name});
       }

       if(this.state.market && this.state.market.value){
           params = Object.assign(params,{ market: this.state.market.value});
       }

       if(this.state.status && this.state.status.value){
           params = Object.assign(params,{ status_label: this.state.status.value});
       }

       if(this.state.licensePlate.length > 0){
           params = Object.assign(params,{license_plate: this.state.licensePlate});
       }

       if(this.state.model.length > 0){
           params = Object.assign(params,{model_car: this.state.model});
       }

       if(this.state.claimedItemSelected && this.state.claimedItemSelected.value){
           params = Object.assign(params,{claimed_item: this.state.claimedItemSelected.value});
       }

       if(this.state.typeFilterDate == typeFilterDate.creation){
           params = Object.assign(params,{creation_date_from: this.state.startDate.valueOf(),creation_date_to: this.state.endDate.valueOf()});
       }

       if(this.state.typeFilterDate == typeFilterDate.update){
           params = Object.assign(params,{update_date_from: this.state.startDate.valueOf(), update_date_to: this.state.endDate.valueOf()});
       }

       this.props.search(params);
    };

    menuItems = (items) =>  {
        if(items.length == 0 || items[0].value !== labels.all){
            items.unshift({value:labels.all,label:labels.all});
        }

        return items.map((item) => (
            <MenuItem  key={item.value} value={item.value}>{item.label}</MenuItem>
        ));
    };

    validShowLabelDate = () =>{
      if(this.state.typeFilterDate == typeFilterDate.update){
          return <Label>{labels.updateDate}</Label>;
      }
        return <Label>{labels.creationDate}</Label>;
    };

    render() {
        return (
            <div className="div-margin-top fieldset-filter form-group">
                <Row className="fieldset-board" >
                    <Col className="col-md-3">
                        <label >
                            {labels.claimedItem}
                        </label>
                        <MultiSelectField id="multiSelectClaimedItems" data={this.state.claimedItemsData} multi={false} handleSelectChange={this.changeClaimedItems}
                                          valuesSelected={this.state.claimedItemSelected} placeHolder={labels.claimedItem} />
                    </Col>
                    <Col className="col-md-3 col-radio">
                        <FormGroup check>
                            <Label check>
                                <Input type="radio" name="chkCreationDate" checked={this.state.typeFilterDate == typeFilterDate.creation} onChange={() => this.onChangeTypeFilterDate(typeFilterDate.creation)}/>{' '}{labels.creationDate}
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <Input type="radio" name="chkUpdateDate" checked={this.state.typeFilterDate == typeFilterDate.update} onChange={() => this.onChangeTypeFilterDate(typeFilterDate.update)}/>{' '}{labels.updateDate}
                            </Label>
                        </FormGroup>
                    </Col>

                    <Col className="col-md-3">
                        {this.validShowLabelDate()}

                        <DateRangePicker startDate = {this.state.startDate} endDate = {this.state.endDate} maxDate = {moment()}
                                         oneDate={false} handleEvent = {this.handleEvent}/>
                    </Col>
                    <Col className="col-md-3">
                        <Label >
                            {labels.status}
                        </Label>
                        <MultiSelectField id="multiSelectClaimedItems" data={this.state.dataStatus} multi={false} handleSelectChange={this.changeStatus}
                                          valuesSelected={this.state.status} placeHolder={labels.status} />
                    </Col>
                </Row>
                <Row className="fieldset-board" >
                    <Col className="col-md-3">
                        <FormGroup>
                            <Label for="registration">{labels.registration}</Label>
                            <Input name="registration" id="registration" placeholder={labels.registration}
                                   value={this.state.registration} onChange={evt => this.changeRegistration(evt)}/>
                        </FormGroup>
                    </Col>
                    <Col className="col-md-3">
                        <FormGroup>
                            <Label for="name">{labels.name}</Label>
                            <Input name="name" id="name" placeholder={labels.name}
                                   value={this.state.name} onChange={evt => this.changeName(evt)}/>
                        </FormGroup>
                    </Col>
                    <Col className="col-md-3">
                        <Label >
                            {labels.profile}
                        </Label>
                        <MultiSelectField id="multiSelectProfile" data={this.state.dataTypeUser} multi={false} handleSelectChange={this.changeTypeUser}
                                          valuesSelected={this.state.typeUserSelected} placeHolder={labels.profile} />
                    </Col>
                    <Col className="col-md-3">
                        <label >
                            {labels.market}
                        </label>
                        <MultiSelectField id="multiSelectMarket" data={this.state.dataMarket} multi={false} handleSelectChange={this.changeMarket}
                                          valuesSelected={this.state.market} placeHolder={labels.market} />
                    </Col>
                </Row>

                <Row className="fieldset-board" >
                    <Col className="col-md-3 ">
                        <FormGroup>
                            <Label for="licensePlate">{labels.plateVehicle}</Label>
                            <Input name="licensePlate" id="licensePlate" placeholder={labels.plateVehicle}
                                   value={this.state.licensePlate} onChange={evt => this.changeLicensePlate(evt)}/>
                        </FormGroup>
                    </Col>
                    <Col className="col-md-3 ">
                        <FormGroup>
                            <Label for="model">{labels.model}</Label>
                            <Input name="model" id="model" placeholder={labels.model}
                                   value={this.state.model} onChange={evt => this.changeModel(evt)}/>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <div className="div-button">
                        <FormControl className="buttonSearch">
                            <Button variant="contained"  color="primary" onClick={this.search}>
                                <FontAwesome name='search'/> &nbsp;&nbsp;{labels.search}
                            </Button>
                        </FormControl>
                    </div>
                </Row>
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./src/components/filterExperience/FilterExperience.js